// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"a3cd1c4e","464":"a88d2794","719":"d10021eb","787":"5128b469"}[chunkId] + ".chunk.js";
};